import React from 'react'
import SvgIcon, { SvgIconProps } from 'components/Luxkit/SvgIcon'

function LineDoorIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M21.2896 19.6599h-1.54v-13.4a2.2 2.2 0 0 0-2.23-2.16h-1.52v-.16a2.2601 2.2601 0 0 0-2.56-2.23l-7.22 1.06A2.25 2.25 0 0 0 4.2496 5v14.53h-1.4a1.0002 1.0002 0 0 0-.7071 1.7072 1 1 0 0 0 .7071.2928h12.15a1 1 0 0 0 1-1V6.1h1.55c.13 0 .23.08.23.16v14.4a1 1 0 0 0 1 1h2.54a1 1 0 1 0 0-2h-.03Zm-7.29-.13h-7.75v-14.53a.27.27 0 0 1 .24-.25l7.19-1.06a.26.26 0 0 1 .29.25l.03 15.59Zm-2.09-5.65a1.07 1.07 0 0 1-1.07-1.07v-1.14a1.0692 1.0692 0 0 1 .2727-.8224 1.0693 1.0693 0 0 1 .7923-.3509 1.0693 1.0693 0 0 1 .7923.3509 1.0692 1.0692 0 0 1 .2727.8224v1.14a1.0605 1.0605 0 0 1-.3174.7669 1.0575 1.0575 0 0 1-.3554.2303 1.0584 1.0584 0 0 1-.4172.0728h.03Z"/>
  </SvgIcon>
}

export default LineDoorIcon
